import { onBeforeUnmount } from 'vue';
function useScrollEChartData(options, cb) {
    let timer = null;
    let lastIdx = 0;
    let curChartData = [];
    const startScroll = () => {
        if (options.showCount >= options.chartData.length) {
            curChartData = options.chartData;
            cb(curChartData);
        }
        else {
            if (!(curChartData === null || curChartData === void 0 ? void 0 : curChartData.length)) {
                for (let i = 0; i < options.showCount; i++) {
                    curChartData.push(options.chartData[i]);
                }
                lastIdx = options.showCount;
                cb(curChartData);
            }
            options.scrollCount > 0 && startTimer();
        }
    };
    const startTimer = () => {
        var _a;
        timer = window.setInterval(() => {
            if (!timer)
                return;
            curChartData.splice(0, options.scrollCount);
            for (let i = lastIdx; i < lastIdx + options.scrollCount && i < options.chartData.length && curChartData.length < options.showCount; i++) {
                curChartData.push(options.chartData[i]);
            }
            lastIdx = lastIdx + Math.min(options.scrollCount, options.showCount);
            if (curChartData.length < options.showCount) {
                if (options.seamless === false) {
                    lastIdx = 0;
                }
                else {
                    lastIdx = options.showCount - curChartData.length;
                    for (let i = 0; i < lastIdx; i++) {
                        curChartData.push(options.chartData[i]);
                    }
                }
            }
            cb(curChartData);
        }, (_a = options.interval) !== null && _a !== void 0 ? _a : 10000);
    };
    const stopScroll = () => {
        timer && window.clearInterval(timer);
        timer = null;
    };
    onBeforeUnmount(() => {
        stopScroll();
        lastIdx = 0;
        curChartData = [];
    });
    return {
        startScroll,
        stopScroll,
    };
}
export { useScrollEChartData };
